var _a;
const runtimeConfig = (_a = window.getRuntimeConfig) == null ? void 0 : _a.call(window, "v2");
const volcConfigForMergeSinf = {
  enabled: true,
  redirectDomainID: "sinf"
};
const defaultVolcConfig = {
  online: volcConfigForMergeSinf,
  hl: volcConfigForMergeSinf,
  boe: volcConfigForMergeSinf,
  sandbox: volcConfigForMergeSinf
};
const generateGlobalConfig = () => {
  var _a2, _b, _c;
  const customConfig = (_a2 = runtimeConfig == null ? void 0 : runtimeConfig.customConfig) == null ? void 0 : _a2.pages;
  const domainID = ((_b = runtimeConfig == null ? void 0 : runtimeConfig.baseConfig) == null ? void 0 : _b.domainID) || "unknown";
  return {
    domainID,
    volcConfig: (customConfig == null ? void 0 : customConfig.volcConfig) || defaultVolcConfig[domainID] || { enabled: false },
    cloudSite: (_c = runtimeConfig == null ? void 0 : runtimeConfig.baseConfig) == null ? void 0 : _c.cloudSite
  };
};
const globalConfig = generateGlobalConfig();
function createLinkMapWithRegion(volcPid, bcPrefix, volcPrefix = "") {
  const bytecloudPrefix = bcPrefix || `/volc_${volcPid.replaceAll("-", "_")}`;
  return [
    {
      matcher: new RegExp(`^${volcPrefix}\\/${volcPid}\\/region:${volcPid}\\+([-\\w]+)(\\/?[^?]*?)$`),
      // 不带query参数的matcher
      replacer: `${bytecloudPrefix}$2?x-bc-region-id=volc&x-resource-account=public&x-bc-vregion=$1`
    },
    {
      matcher: new RegExp(`^${volcPrefix}\\/${volcPid}\\/region:${volcPid}\\+([-\\w]+)(\\/?.*?)$`),
      // 带query参数的matcher
      replacer: `${bytecloudPrefix}$2&x-bc-region-id=volc&x-resource-account=public&x-bc-vregion=$1`
    },
    {
      matcher: new RegExp(`^${volcPrefix}\\/${volcPid}(\\/?)$`),
      // 不带region的matcher
      replacer: `${bytecloudPrefix}$1`
    }
  ];
}
function createLinkMapWithRegion2(prefixWithRegion, bytecloudPrefix) {
  const prefixWithOutRegion = prefixWithRegion.split(/\/region:/)[0];
  return [
    {
      matcher: new RegExp(`^${prefixWithRegion}\\+([-\\w]+)(\\/?[^?]*?)$`),
      // 不带query参数的matcher
      replacer: `${bytecloudPrefix}$2?x-bc-region-id=volc&x-resource-account=public&x-bc-vregion=$1`
    },
    {
      matcher: new RegExp(`^${prefixWithRegion}\\+([-\\w]+)(\\/?.*?)$`),
      // 带query参数的matcher
      replacer: `${bytecloudPrefix}$2&x-bc-region-id=volc&x-resource-account=public&x-bc-vregion=$1`
    },
    {
      matcher: new RegExp(`^${prefixWithOutRegion}(\\/?)$`),
      // 不带region的matcher
      replacer: `${bytecloudPrefix}$1`
    }
  ];
}
function createRdsLinkMap(volcPid, prefix) {
  const bytecloudPrefix = prefix || `/volc_${volcPid.replaceAll("-", "_")}`;
  return [
    {
      matcher: new RegExp(`^\\/db\\/region:db\\+([-\\w]+)\\/${volcPid}\\/?([^?]*?)$`),
      // 不带query参数的matcher
      replacer: `${bytecloudPrefix}/$2?x-bc-region-id=volc&x-resource-account=public&x-bc-vregion=$1`
    },
    {
      matcher: new RegExp(`^\\/db\\/region:db\\+([-\\w]+)\\/${volcPid}\\/?(.*?)$`),
      // 带query参数的matcher
      replacer: `${bytecloudPrefix}/$2&x-bc-region-id=volc&x-resource-account=public&x-bc-vregion=$1`
    }
  ];
}
const supportVolcLinkMappingList = [
  {
    matcher: /^\/bi\/datawind/,
    replacer: "/datawind"
  },
  {
    matcher: /^\/livesaas/
  },
  ...createLinkMapWithRegion("vke", "/vke_volc"),
  {
    matcher: /^\/dataleap/
  },
  ...createLinkMapWithRegion("flink"),
  {
    matcher: /^\/datafinder/
  },
  {
    matcher: /^\/datatester/
  },
  ...createLinkMapWithRegion("bytehouse-ce", "/bytehouse_ce"),
  ...createLinkMapWithRegion("bytehouse", "/bytehouse"),
  ...createLinkMapWithRegion("datasail", "/datasail"),
  {
    matcher: /^\/las/
  },
  {
    matcher: /^\/cdp/
  },
  {
    matcher: /^\/cloud-detect/,
    replacer: "/volc_cloud_detect"
  },
  ...createLinkMapWithRegion("metrics", "/volc_metrics", "/cloud-monitor"),
  {
    matcher: /^\/cloud-monitor/,
    replacer: "/cloud_monitor"
  },
  ...createLinkMapWithRegion("cfs", "/cfs"),
  {
    matcher: /^\/ACEP/,
    replacer: "/acep"
  },
  {
    matcher: /^\/veGame/,
    replacer: "/vegame"
  },
  {
    matcher: /^\/ark\//,
    replacer: "/ark/"
  },
  ...createLinkMapWithRegion("cr"),
  {
    matcher: /^\/cr\//,
    // cr存在特定链接不带region 经过确定是bug 短期先这么处理
    replacer: "/volc_cr/"
  },
  ...createLinkMapWithRegion("vpc", "/volc_vpc/vpc"),
  ...createLinkMapWithRegion("eip", "/volc_vpc/eip"),
  ...createLinkMapWithRegion("nat", "/volc_vpc/nat"),
  ...createLinkMapWithRegion("vpn", "/volc_vpc/vpn"),
  ...createLinkMapWithRegion("pl", "/volc_vpc/pl"),
  ...createLinkMapWithRegion("tls"),
  ...createLinkMapWithRegion("clb", "/volc_clb/clb"),
  ...createLinkMapWithRegion("nlb", "/volc_clb/nlb"),
  ...createLinkMapWithRegion("prometheus"),
  ...createLinkMapWithRegion("milvus", "/milvus"),
  ...createLinkMapWithRegion("rds-pg", "/rds_pg"),
  ...createRdsLinkMap("rds-pg", "/rds_pg"),
  ...createLinkMapWithRegion("ml-platform"),
  ...createLinkMapWithRegion2("/vikingdb/memory/region:vdb-memory", "/vdb_memory"),
  ...createLinkMapWithRegion("apmplus-server", "/volc_apmplus/apmplus-server"),
  ...createLinkMapWithRegion("apmplus", "/volc_apmplus/apmplus"),
  ...createLinkMapWithRegion("db-ai", "/db_ai"),
  ...createLinkMapWithRegion("aidap", "/aidap"),
  ...createLinkMapWithRegion("context-search", "/context_search")
];
const LOCAL_LOGIN_DURATION_LS_KEY_PREFIX = "VOLC_LOCAL_COOKIE_LOGIN_SESSION";
export {
  LOCAL_LOGIN_DURATION_LS_KEY_PREFIX,
  globalConfig,
  supportVolcLinkMappingList
};
